const twizFormats = {};

import hopkinsUniversity from "./hopkins_university";
twizFormats["hopkins_university"] = hopkinsUniversity;

import missouri from "./missouri";
twizFormats["missouri"] = missouri;

import unc from "./unc";
twizFormats["unc"] = unc;

import mayo from "./mayo";
twizFormats["mayo"] = mayo;

import colorado from "./colorado";
twizFormats["colorado"] = colorado;

export { twizFormats };
